export interface TranslatableName {
  name: string;
  name_translations?: Record<string, string> | null;
}

export function pickTranslatedName(
  source: TranslatableName | null | undefined,
  lang: string | null | undefined
): string {
  const translations = source?.name_translations;
  if (!translations || !lang) {
    return source?.name ?? '';
  }
  if (translations[lang]) {
    return translations[lang];
  }
  const subtag = lang.toLowerCase().split('-')[0];
  const matchKey = Object.keys(translations).find(
    (key) => key.toLowerCase().split('-')[0] === subtag
  );
  return (matchKey && translations[matchKey]) || source.name;
}

export function nameMatches(
  source: TranslatableName | null | undefined,
  lang: string | null | undefined,
  search: string
): boolean {
  const needle = search.toLocaleLowerCase();
  return [pickTranslatedName(source, lang), source?.name ?? ''].some((name) =>
    name.toLocaleLowerCase().includes(needle)
  );
}

export interface CategoryName extends TranslatableName {
  overwritten_names?: string[];
  overwritten_names_translations?: Record<string, string>[] | null;
}

export function categoryDisplayName(
  category: CategoryName | null | undefined,
  lang?: string | null
): string {
  const overrides = category?.overwritten_names;
  if (!overrides?.length) {
    return pickTranslatedName(category, lang);
  }
  return overrides
    .map((name, index) =>
      pickTranslatedName(
        {
          name,
          name_translations: category.overwritten_names_translations?.[index]
        },
        lang
      )
    )
    .toString();
}
